import React, { useEffect, useState } from 'react';
import useNavigationService from '../service/api/useNavigationService';
import useAuthService from '../service/api/useAuthService';

const SelectDomain = () => {
  const { loading, domains, error } = useAuthService();
  const { navigateToDashboard } = useNavigationService();
  const [userSelected, setUserSelected] = useState(false);

  useEffect(() => {
    // Dès que les données sont chargées, si l'un des domaines a isDefault à true, on redirige automatiquement
    if (!loading && domains.length > 0) {
      const defaultDomain = domains.find((d) => d.isDefault === true);
      if (defaultDomain) {
        navigateToDashboard(defaultDomain);
      }
    }
  }, [loading, domains, navigateToDashboard]);

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (error) {
    return <div>Une erreur s'est produite.</div>;
  }

  // Si un domaine par défaut existe, la redirection a déjà eu lieu, on n'affiche rien
  const hasDefault = domains.some((d) => d.isDefault === true);
  if (hasDefault) {
    return null;
  }

  // Sinon, on laisse l'utilisateur choisir son domaine
  const lang = navigator.language.startsWith("fr") ? "fr" : "en";

  const handleDomainSelect = (domain) => {
    setUserSelected(true);
    navigateToDashboard(domain);
  };

  // On affiche la liste des domaines si l'utilisateur n'a pas encore sélectionné manuellement
  if (userSelected) {
    return null;
  }

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center min-vh-100">
      <div
        className="card shadow-lg rounded text-center p-4"
        style={{ maxWidth: "500px", width: "100%", margin: "20px" }}
      >
        <h2 className="mb-3 text-primary">
          {lang === "fr" ? "Sélectionnez un domaine" : "Select a domain"}
        </h2>
        <p className="mb-4 text-secondary" style={{ fontSize: "0.95rem" }}>
          {lang === "fr"
            ? "Vous devez choisir un domaine pour accéder au site."
            : "You must select a domain to access the site."}
        </p>
        <ul className="list-group">
          {domains.length > 0 ? (
            domains.map((domain) => (
              <li
                key={domain.id}
                className="list-group-item p-3"
                style={{ borderRadius: "8px", marginBottom: "10px" }}
              >
                <button
                  onClick={() => handleDomainSelect(domain)}
                  className="btn btn-outline-primary w-100 d-flex justify-content-between align-items-center"
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    padding: "10px 15px",
                  }}
                >
                  <span>
                    {domain.name}{" "}
                    <strong>
                      (
                      {domain.role ||
                        (lang === "fr"
                          ? "Rôle non défini"
                          : "Undefined role")}
                      )
                    </strong>
                  </span>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </li>
            ))
          ) : (
            <li className="list-group-item text-center text-muted">
              {lang === "fr"
                ? "Aucun domaine disponible."
                : "No domains available."}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default SelectDomain;
